import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "mbe_sid";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SID_KEY);
    if (!sid) {
      sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

/**
 * Fires ONE analytics/track call per browser session per page.
 * Silent on network failure — never blocks rendering.
 */
export function useTrackPageView(page) {
  useEffect(() => {
    if (!page) return;
    try {
      const key = `mbe_tracked_${page}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch { /* ignore */ }
    const body = {
      page,
      session_id: getSessionId(),
      referrer: (typeof document !== "undefined" && document.referrer) || null,
    };
    axios.post(`${API}/analytics/track`, body).catch(() => {});
  }, [page]);
}
